import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../common/form';

import * as utils from '../../utils/utilities';

class HelideckDrawingSheetForm extends Form {
	state = {
		data: {
			drawingSheet: [],
		},
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		drawingSheet: Joi.array().min(1).required().label('Dry Condition Images'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.drawingSheet);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 1,
					multiple: false,
					name: 'drawingSheet',
					accept: 'image/*,application/pdf',
					label: 'Helideck Drawing',
					sublabel: 'Upload Helideck Drawing Images',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default HelideckDrawingSheetForm;
